import { useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { ApolloQueryResult } from '@apollo/client';
import {
  GlobalCollectorSettingEnabledForMeInput,
  IsGlobalCollectorSettingEnabledForMeQuery,
  useIsGlobalCollectorSettingEnabledForMeQuery
} from 'graphql/types';
export const useIsScreentimeEnabledForMe = ({
  input,
  skip
}: {
  input: GlobalCollectorSettingEnabledForMeInput;
  skip?: boolean;
}): {
  isScreentimeEnabledForMe: boolean;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (
    variables?: any
  ) => Promise<ApolloQueryResult<IsGlobalCollectorSettingEnabledForMeQuery>>;
} => {
  const result = useIsGlobalCollectorSettingEnabledForMeQuery({
    variables: {
      input: input
    },
    skip,
    fetchPolicy: 'cache-and-network'
  });

  return useMemo(
    () => ({
      loading: result?.loading,
      error: result?.error,
      isScreentimeEnabledForMe: Boolean(
        result?.data?.isGlobalCollectorSettingEnabledForMe
      ),
      refetch: result?.refetch
    }),
    [result]
  );
};
